import stationsRaw from '../data/stations.json'

const stations = stationsRaw.features.map((f: any) => {
  return {
    name: f.properties.Name,
    lat: f.geometry.coordinates[1],
    lng: f.geometry.coordinates[0],
  }
})

import findNearest from './findNearest'

export default async function findNearestStation(start: any) {
  return findNearest(start, stations)
}



// WEBPACK FOOTER //
// ./src/lib/findNearestStation.ts